import BookPromptGroup from "components/BookGroup/groups/BookPromptGroup";
import Divider from "components/ui/Divider";
import Container from "hardcover-ui/components/Container";
import Heading from "hardcover-ui/components/Heading";
import { PageSerializersBooksShow, PromptSerializersPrompt } from "types/serializers";

export default function BookPrompts({ book, prompts }: { book: PageSerializersBooksShow; prompts: PromptSerializersPrompt[] }) {

  if (prompts.length === 0) {
    return <></>;
  }

  return (
    <Container variant="layout" size="md">
      <Heading level={2} size="md">
        Top Prompts
      </Heading>

      <div className="space-y-12 mt-4">
        {prompts.map((prompt) => (
          <BookPromptGroup
            key={`book-prompt-${prompt.id}`}
            prompt={prompt}
            activeBook={book}
            size={prompt.featured ? "lg" : "md"}
            context={{ maxBooks: 12 }}
          />
        ))}
      </div>

      <Divider size="lg" />
    </Container>
  );
}
